<template>
  <div class="ma-3">
    <div class="title mb-3">
      Address book <v-icon>mdi-chevron-right</v-icon> School types management <v-icon>mdi-chevron-right</v-icon> {{ isNew ? 'New' : type.name }}
    </div>

    <v-form
      ref="form"
      v-model="formValid"
      layout="column"
      layout-align="center center"
      @submit.prevent="save"
    >
      <div>
        <div class="title font-weight-light mb-3">
          Type information
        </div>
        <v-text-field
          v-model="type.name"
          outline
          label="Name"
          class="field-width"
          :rules="[ v => !!v || 'This field is required' ]"
        />
        <v-select
          v-model="type.position"
          v-focus
          :items="positions"
          outline
          label="Position"
          :rules="[ v => !!v || 'This field is required' ]"
        />
      </div>

      <v-btn
        depressed
        color="primary"
        @click="save"
      >
        Save
      </v-btn>
      <router-link
        :to="{name: 'admin-addressbook-schooltypes-index'}"
        class="grey--text"
      >
        Cancel
      </router-link>
    </v-form>
  </div>
</template>

<script>
    import Params from '@/api/params'

    export default {
        data () {
            return {
                type: {
                    name: null,
                    position: null
                },
                formValid: false,
                positions: []
            }
        },
        computed: {
            isNew () {
                return this.$route.params.id === 'new';
            }
        },
        mounted () {
            if (!this.isNew) {
                this.fetch();
            }

            this.handlePositions()
        },
        methods: {
            fetch () {
                Params.get('schools-types', this.$route.params.id).then(res => {
                    this.type = res.data;
                })
            },
            save () {
                if (!this.$refs.form.validate()) {
                    return;
                }

                if (this.isNew) {
                    Params.create('schools-types', this.type).then(() => {
                        this.$router.push({name: 'admin-addressbook-schooltypes-index'});
                        this.$snotify.success(`The school type "${this.type.name}" has been created`)
                    })
                } else {
                    Params.update('schools-types', this.type.id, this.type).then(() => {
                        this.$router.push({name: 'admin-addressbook-schooltypes-index'});
                        this.$snotify.success(`The school type "${this.type.name}" has been updated`)
                    })
                }
            },
            handlePositions () {
                let types = []
                this.positions = []
                Params.getList('schools-types').then(res => {
                    types = res.data
                    let max
                    if (this.isNew || types.length === 0) {
                        max = types.length + 1
                    } else {
                        max = types.length
                    }
                    for (let i = 1; i <= max; i++) {
                        this.positions.push({ text: i, value: i })
                    }
                    if (this.isNew) {
                        this.type.position = max
                    }
                })
            }
        }
    }
</script>